import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { setPostTiles } from '../../../lib/redux/campaignDnd/campaignDndSlice';
import { get } from '../../../lib/api';
import { setScrollPosition } from '../../../lib/redux/campaignScroll/campaignScrollSlice';

export const useFetchCampaign = ({
  id,
  forceRefetch = false,
  scrollPosition,
  page,
}) => {
  const dispatch = useDispatch();

  const {
    data: { campaign },
    isFetching,
    error,
    refetch,
  } = useQuery(
    ['campaignData', id],
    () => get(`/api/client_admin/campaigns/${id}`),
    {
      placeholderData: { campaign: { post: [] } },
      enabled: !!id,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );

  if (error?.response?.status === 401) {
    window.location.replace('/client_admin/campaigns');
  }

  useEffect(() => {
    if (campaign?.posts) {
      dispatch(setPostTiles(campaign.posts));
    }
  }, [campaign, dispatch]);

  useEffect(() => {
    if (scrollPosition && !isFetching) {
      setTimeout(() => {
        window.scrollTo(0, scrollPosition);
        dispatch(setScrollPosition({ page, scrollPosition: 0 }));
      }, 0);
    }
  }, [scrollPosition, isFetching, dispatch, page]);

  useEffect(() => {
    if (forceRefetch) {
      refetch();
    }
  }, [forceRefetch, refetch]);

  return { campaign, isFetching };
};

export const useGetCampaignDates = ({ campaignId }) => {
  const queryClient = useQueryClient();

  const {
    campaign: { startDate, endDate, posts, boardTimezone },
  } = queryClient.getQueryData(['campaignData', campaignId]);

  const postDates = posts.reduce((acc, post) => {
    if (post.publishDate) {
      return [...acc, post.publishDate];
    }
    return acc;
  }, []);

  return { startDate, endDate, postDates, boardTimezone };
};
